import getConfig from 'next/config';
import type { AxiosResponse } from 'axios';

// This seems like it should not be imported here
// Move APIs below into car finance folder?
import type {
  FormPayloadSchema,
  LoanRequest,
} from '../components/CarFinancePage/queries/schema/carFinance.schema';
import { motorFinanceGateway } from '../api/api-utils/commonApiUtils';

const getCarFinance = (params: string) => {
  const {
    publicRuntimeConfig: { API_CLIENT_TIMEOUT },
  } = getConfig();
  return motorFinanceGateway.get(`/v1/finance/application/load${params}`, {
    timeout: API_CLIENT_TIMEOUT,
  });
};

const loan = (payload: LoanRequest) => {
  const {
    publicRuntimeConfig: { API_CLIENT_TIMEOUT },
  } = getConfig();
  return motorFinanceGateway.post('/v1/finance/calculate/loan', payload, {
    timeout: API_CLIENT_TIMEOUT,
  });
};

const submit = (payload: FormPayloadSchema) => {
  const {
    publicRuntimeConfig: { API_CLIENT_TIMEOUT },
  } = getConfig();
  return motorFinanceGateway.post<AxiosResponse<unknown>>(
    '/v1/finance/application/apply',
    payload,
    {
      timeout: API_CLIENT_TIMEOUT,
    },
  );
};

export const carFinanceApi = {
  getCarFinance,
  loan,
  submit,
};
